export default{
	lang:{
		title: 'ئۆتكۈرگۈچ سىزىق دىئاگراممىسىنى سوراش',
		language: 'تىل',
		brand: "ماركا",
		carName: "ئۆتكۈرگۈچ تىپى",
		searchMC: "سىستېما ئاتى",
		searchMS: "سىستېما چۈشەندۈرۈشى",
		jumper: "ئۇلاش سىزىق ID-sى",
		buuton1: " ئىزدەش",
		desOption:['باتارېيە بوغچىسىنى تەكشۈرۈش','ئۈستۈنكى پىرېسسور','ئاستىدىكى پىرېسسور'],
		report:{
			shebei1: 'دىن',
			shebei2: 'تەكشۈرۈش ئۈسكۈنىسى تەمىنلەيدۇ',
			oneTitle: 'تەكشۈرۈش نەتىجىسى',
			ver: 'ماشىنا نومۇرى بەلگىلەنمىگەن',
			vin: 'شاسسە نومۇرى(VIN)',
			bianhao: 'دوكلات نومۇرى',
			jcTime: 'تەكشۈرۈش ۋاقتى',
			bms: 'BMS تەكشۈرۈش نەتىجىسى',
			tips: 'ئەسكەرتىش',
			tipText: '«قوللىمايدۇ» دېگەن سۆز «باتارېيە بوغچىسى تەكشۈرۈشى» بۇ تۈرلۈك سانلىق مەلۇماتنى ئوقۇشنى قوللىمايدىغانلىقىنى بىلگۈرىدۇ. پۈتۈن ئۆتكۈرگۈچ دىياگنوزىكىسى ئاستىدىكى BMS (باتارېيە باشقۇرۇش سىستېمىسى) نى تاللاپ، سانلىق مەلۇمات ئېقىمىنى ئوقۇپ كۆرۈپ بېقىڭ.',
			soc: 'SOC قالغان توك مىقدارى',
			soh: 'SOH باتارېيە ساغلاملىق دەرىجىسى',
			Vname1: 'ئومۇمىي توك بېسىمى',
			Vname2: 'باتارېيە گىرىمىنىڭ توك تولۇقلىشى ۋە بوشىتۇش سانى',
			Vname3: 'ئەڭ يۇقىرى يەككە باتارېيە توك بېسىمى',
			Vname4: 'ئەڭ يۇقىرى يەككە باتارېيە تېمپېراتۇرىسى',
			Vname5: 'ئەڭ تۆۋەن يەككە باتارېيە توك بېسىمى',
			Vname6: 'ئەڭ تۆۋەن يەككە باتارېيە تېمپېراتۇرىسى',
			Vname7: 'بېسىم پەرقى',
			Vname8: 'ئىزولياتسىيە قارشىلىق قىممىتى',
			bms: 'BMSتەكشۈرۈش تەپسىلاتى',
			tab1: 'تەكشۈرۈش تۈرى',
			tab2: 'تەكشۈرۈش نەتىجىسى',
			tab3: 'بىرلىك',
			dtdy: 'توك كۈچى',
			max: 'ئەڭ يۇقىرى',
			min: 'ئەڭ تۆۋەن',
			dcwd: 'ئاۋازلىق',
			shengcheng: 'PDF ھۆججىتى ھاسىل قىلىش',
			jcsb: 'تەكشۈرۈش ئۈسكۈنىسى',
			sbbh: 'ئۈسكۈنە نومۇرى',
		}
	}
}